export enum ColonnadePointType {
  TERMINUS = "TERMINUS",
  COLUMN = "COLUMN",
  COLUMN_DIM = "COLUMN_DIM",
  MULTI_COLUMN_DIM = "MULTI_COLUMN_DIM",
  MULTI_COLUMN = "MULTI_COLUMN",
}

export interface ColonnadePoint {
  readonly type: ColonnadePointType;
  readonly x: number;
  readonly y: number;
  readonly width?: number;
  readonly halfEdges: (number | undefined)[];
}
